import { OUTLAW_QUERY_PARAMS, ProfileService } from '@outlaw/core';
import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { isGuestToken } from '../util';

// todo: refactor to service
export const userDetailsResolver: ResolveFn<Observable<boolean>> = (
  route: ActivatedRouteSnapshot,
) => {
  const profileService = inject(ProfileService);

  const user = profileService.getUser();
  let userToken = profileService.getUserToken();
  const queryToken = route.queryParams[OUTLAW_QUERY_PARAMS.token];

  if (user) {
    if (!userToken || isGuestToken(userToken)) {
      profileService.removeUser();
    }

    if (!queryToken) {
      return of(true);
    }

    return of(true);
  }

  if (!userToken && queryToken) {
    userToken = queryToken;
    profileService.updateUserToken(queryToken, { saveToLocalStorage: true });
    // for iframe
  }

  if (!userToken) {
    return of(false);
  }

  if (isGuestToken(userToken)) {
    // Argo Guest Token
    return of(false);
  }

  return of(false);
};
